import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './locales/en.json';
import ar from './locales/ar.json';
import ur from './locales/ur.json';
import fr from './locales/fr.json';

export const SUPPORTED_LANGUAGES = [
    { code: 'en', name: 'English', native: 'English', flag: '🇬🇧', dir: 'ltr' },
    { code: 'ar', name: 'Arabic', native: 'العربية', flag: '🇸🇦', dir: 'rtl' },
    { code: 'ur', name: 'Urdu', native: 'اردو', flag: '🇵🇰', dir: 'rtl' },
    { code: 'fr', name: 'French', native: 'Français', flag: '🇫🇷', dir: 'ltr' },
];

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            en: { translation: en },
            ar: { translation: ar },
            ur: { translation: ur },
            fr: { translation: fr },
        },
        fallbackLng: 'en',
        supportedLngs: ['en', 'ar', 'ur', 'fr'],
        detection: {
            order: ['localStorage', 'navigator', 'htmlTag'],
            caches: ['localStorage'],
            lookupLocalStorage: 'nikayofx_lang',
        },
        interpolation: {
            escapeValue: false,
        },
    });

// Update document direction and language attribute on language change
const applyLanguageAttributes = (lng) => {
    const lang = SUPPORTED_LANGUAGES.find((l) => l.code === lng) || SUPPORTED_LANGUAGES[0];
    document.documentElement.lang = lang.code;
    document.documentElement.dir = lang.dir;
    document.body.dir = lang.dir;
};

applyLanguageAttributes(i18n.language);
i18n.on('languageChanged', applyLanguageAttributes);

// Geo boost: first-time visitors from Arabic-speaking countries auto-switch to Arabic
// (never overrides a manual language choice)
const ARABIC_COUNTRIES = ['SA', 'EG', 'AE', 'KW', 'QA', 'BH', 'OM', 'JO', 'IQ', 'SY', 'LB', 'PS', 'YE', 'SD', 'LY'];

const maybeGeoLangSwitch = () => {
    try {
        if (localStorage.getItem('nikayofx_lang_manual')) return;
        if (localStorage.getItem('nikayofx_geo_lang_done')) return;
        const cached = JSON.parse(localStorage.getItem('nikayofx_geo') || 'null');
        const cc = cached && cached.cc;
        if (!cc) return;
        localStorage.setItem('nikayofx_geo_lang_done', '1');
        if (ARABIC_COUNTRIES.includes(cc) && i18n.language !== 'ar') {
            i18n.changeLanguage('ar');
        }
    } catch { /* ignore */ }
};

maybeGeoLangSwitch();
if (typeof window !== 'undefined') {
    window.addEventListener('nikayofx:geo', maybeGeoLangSwitch);
}

export default i18n;
